module.exports = __webpack_public_path__ + "static/img/7.af03bb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dww/7.png
// module id = u4+J
// module chunks = 0